<template>
  <div>
    <small class="caption">
      <strong>ANS</strong><br />
      {{ beneficiarioPinss ? beneficiarioPinss.ansTelefone : "" }}<br />
      www.ans.gov.br/aans/nossos-enderecos<br />
      {{ beneficiarioPinss ? beneficiarioPinss.ansSite : "" }}
    </small>
  </div>
</template>

<script>
export default {
  name: "Beneficiario",
  props: {
    beneficiarioPinss: Object
  }
};
</script>

<style scoped lang="scss">
.pinss {
  p {
    margin-bottom: 8px;
  }
}
</style>
